import { Action } from "redux";
import { TacticalPartGroup } from "../model";

export const SET_TACTICAL_PART_GROUPS = "SET_TACTICAL_PART_GROUPS";

export interface TacticalPartGroupsAction extends Action<string> {
    tacticalPartGroups: TacticalPartGroup[];
}